var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"onboard-quiz__cont"},[_c('div',{staticClass:"onboard-iframe"},[_c('content-header'),_vm._v(" "),_c('div',{staticClass:"iframe-intro__cont"},[_c('iframe',{staticClass:"mt--200 resource__iframe",attrs:{"src":_vm.content.url,"width":_vm.content.settings.width,"height":_vm.content.settings.height}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }